export enum PermissionScope {
    View = 1,
}
